import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Box,
    Button,
    FormControlLabel,
    Grid,
    Paper,
    Radio,
    RadioGroup,
    TextField,
    Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ChangeEventFunc } from 'types';
// import { getVariables } from 'service/variable-service';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';

import { gridSpacing } from 'store/constant';
import { getValuesAsync } from 'service/chart-service';
import LineChart from 'ui-component/LineChart';
import { getDeviceByIDAsync } from 'service/device-service';
import ReusableList from 'ui-component/lhp-components/List';
import { Content, ListProps } from 'types/list';
import { ChartAnnotation, StateIndex } from 'types/chart';
import DeviceAccordion from 'ui-component/DeviceAccordion';

const LogsTable = () => {
    localStorage.setItem('currentPage', '/logs-table');

    const [showChart, setShowChart] = React.useState<boolean>(false);
    const [submitted, setSubmitted] = React.useState<boolean>(false);
    const [waitingForResponse, setWaitingForResponse] = React.useState<boolean>(false);

    const [content, setContent] = React.useState<ListProps>({ title: '', content: { data: [], headers: [] }, allowCSVExport: true });

    const [lineDatasets, setLineDatasets] = useState<any[]>([]);
    const [lineDatasetNames, setLineDatasetNames] = useState<any[]>([]);
    const [annotations, setAnnotations] = useState<any[]>([]);

    const [selectedLeftVariables, setSelectedLeftVariables] = useState<string[]>([]);
    const [rightVariables, setRightVariables] = useState<string[]>([]);
    const [leftAxisName, setleftAxisName] = useState<string>('');
    const [rightAxisName, setrightAxisName] = useState<string>('');

    const selectedShowChart = false;

    let annotationColorOptions = new Map();
    annotationColorOptions.set(0, { color: 'rgba(222,61,130,0.2)', name: 'Shutdown' }); // pink
    annotationColorOptions.set(1, { color: 'rgba(64,70,202,0.2)', name: 'Idle' }); // purple
    annotationColorOptions.set(2, { color: 'rgba(15,181,174,0.2)', name: 'Charging' }); // blue
    annotationColorOptions.set(3, { color: 'rgba(114,224,106,0.2)', name: 'Driving' }); //green
    annotationColorOptions.set(4, { color: 'rgba(114,224,106,0.0)', name: 'No State' }); //transparent

    const handleResponse = async (requestBody: any) => {
        //Clear Table
        setContent({ title: '', content: { data: [], headers: [] }, allowCSVExport: true });

        setWaitingForResponse(true);
        setSubmitted(true);
        try {
            let foundDevices = new Map();
            setleftAxisName(requestBody.leftAxisName);
            setrightAxisName(requestBody.rightAxisName);
            setRightVariables(requestBody.rightAxisVariables);
            setSelectedLeftVariables(requestBody.leftAxisVariables);

            const response = await getValuesAsync(requestBody);
            if (selectedShowChart) {
                createLineDatasets(response);
            } else {
                let headers: any[] = ['Customer', 'Project Number', 'Vehicle ID'];
                Object.keys(response[response.length - 1]).forEach((key: any) => {
                    headers.push(key);
                });
                for (let row of response) {
                    if (!foundDevices.has(row.SN)) {
                        const deviceBySN = await getDeviceByIDAsync({ SN: row.SN });
                        foundDevices.set(row.SN, deviceBySN);
                    }
                    const foundDevice = foundDevices.get(row.SN);
                    row.Customer = foundDevice.Customer;
                    row['Project Number'] = foundDevice['Project Number'];
                    row['Vehicle ID'] = foundDevice['Vehicle ID'];
                }
                console.log(response);
                const contentResponse: Content = {
                    data: response,
                    headers: headers.map((header) => {
                        return {
                            title: header,
                            value: header
                        };
                    })
                };
                console.log('TABLE CONTENT', {
                    title: `Results for ${requestBody.vehicles.length} Vehicle(s)`,
                    content: contentResponse,
                    allowCSVExport: true
                });
                setContent({
                    title: `Results for ${requestBody.vehicles.length} Vehicle(s)`,
                    content: contentResponse,
                    allowCSVExport: true
                });
            }
            setShowChart(selectedShowChart);
            setWaitingForResponse(false);
        } catch (error) {
            console.error('Error submitting data:', error);
            setWaitingForResponse(false);
        }
    };

    const createLineDatasets = (liveData: any[]) => {
        let tempArray: any[] = [];
        let tempDataset: any = {
            datasets: []
        };

        const colors = [
            {
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)'
            },
            { borderColor: 'rgb(53, 162, 235)', backgroundColor: 'rgba(53, 162, 235, 0.5)' }
        ];

        setLineDatasetNames(Object.keys(liveData));
        const tempLineDatesetNames = Object.keys(liveData);

        // Loops through keys of serial numbers
        tempLineDatesetNames.forEach((lineDatasetName: any, index: number) => {
            const lineDatasetKeys = Object.keys(liveData[lineDatasetName]);

            tempDataset.datasets = [];
            // Loops through keys of fields for each serial number
            lineDatasetKeys.forEach((lineDatasetKey: any, arrayIndex: number) => {
                if (!lineDatasetKey.includes('States_Indexes')) {
                    tempDataset.datasets.push({
                        label: lineDatasetKey,
                        data: liveData[lineDatasetName][lineDatasetKey],
                        borderColor: colors[arrayIndex].borderColor,
                        backgroundColor: colors[arrayIndex].backgroundColor,
                        tension: 0.2,
                        animation: false,
                        yAxisID: selectedLeftVariables.includes(lineDatasetKey) ? 'left' : 'right'
                    });
                } else {
                    let tempAnnotations: ChartAnnotation[] = [];
                    liveData[lineDatasetName][lineDatasetKey].forEach((stateIndex: StateIndex, i: number) => {
                        if (stateIndex.state === null) stateIndex.state = 4;
                        console.log(
                            stateIndex,
                            annotationColorOptions.get(stateIndex.state).color,
                            annotationColorOptions.get(stateIndex.state).name
                        );
                        tempAnnotations.push({
                            key: i,
                            backgroundColor: annotationColorOptions.get(stateIndex.state).color,
                            title: annotationColorOptions.get(stateIndex.state).name,
                            xMin: stateIndex.startIndex,
                            xMax: stateIndex.endIndex
                        });
                    });
                    setAnnotations(tempAnnotations);
                }
            });
            tempArray.push({ ...tempDataset });
        });
        setLineDatasets(tempArray);
    };

    return (
        <div>
            <DeviceAccordion parentCallback={handleResponse} selectedShowChart={selectedShowChart} UIType={'LOGS'}></DeviceAccordion>
            {submitted ? (
                showChart ? (
                    waitingForResponse ? (
                        <Grid item lg={12} display={'flex'} alignItems={'center'} justifyContent={'center'} paddingTop={'5rem'}>
                            <Box key={'loadingBox'} sx={{ display: 'flex' }}>
                                <CircularProgress />
                            </Box>
                        </Grid>
                    ) : lineDatasets.length > 0 ? (
                        <Paper style={{ width: '100%', marginTop: '20px', padding: '20px' }}>
                            {lineDatasets.map((lineDataset, index) => {
                                return (
                                    <LineChart
                                        key={lineDatasetNames[index]}
                                        chartData={lineDataset}
                                        title={lineDatasetNames[index]}
                                        annotations={annotations}
                                        showRightAxis={rightVariables.length > 0}
                                        leftAxisLabel={leftAxisName}
                                        rightAxisLabel={rightAxisName}
                                    ></LineChart>
                                );
                            })}
                            <Typography style={{ fontSize: '1.3rem', fontWeight: 'bold', textAlign: 'center', padding: '1rem' }}>
                                Highlight Legend
                            </Typography>
                            <Grid
                                container
                                spacing={gridSpacing}
                                flexDirection={'row'}
                                wrap={'wrap'}
                                justifyContent={'center'}
                                paddingLeft={'30px'}
                            >
                                {Array.from(annotationColorOptions.values()).map((annotationColorOption, index) => {
                                    return (
                                        <Grid
                                            key={annotationColorOption.name}
                                            display={'flex'}
                                            flexDirection={'row'}
                                            marginBottom={'0.5rem'}
                                            alignItems={'center'}
                                            justifyContent={'flex-start'}
                                            item
                                            lg={2}
                                        >
                                            <div
                                                key={annotationColorOption.name + index}
                                                style={{
                                                    height: '20px',
                                                    width: '20px',
                                                    borderRadius: '3px',
                                                    border: '1px solid black',
                                                    backgroundColor: annotationColorOption.color,
                                                    marginRight: '0.5rem'
                                                }}
                                            ></div>
                                            {annotationColorOption.name}
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Paper>
                    ) : (
                        <Grid item lg={12} display={'flex'} alignItems={'center'} justifyContent={'center'} paddingTop={'5rem'}>
                            <Typography key={'noResults'} fontWeight={'bold'} fontSize={'2rem'}>
                                No Results for selected criteria
                            </Typography>
                        </Grid>
                    )
                ) : waitingForResponse ? (
                    <Grid item lg={12} display={'flex'} alignItems={'center'} justifyContent={'center'} paddingTop={'5rem'}>
                        <Box key={'loadingList'} sx={{ display: 'flex' }}>
                            <CircularProgress />
                        </Box>
                    </Grid>
                ) : (
                    <Grid item lg={12} paddingTop={'1rem'}>
                        <ReusableList
                            key={'reusableList'}
                            title={content.title}
                            content={content.content}
                            allowCSVExport={content.allowCSVExport}
                        ></ReusableList>
                    </Grid>
                )
            ) : (
                <div></div>
            )}
        </div>
    );
};

export default LogsTable;
